import React from "react";
import { NotFoundPage } from '@kursk/components/pages/404/NotFoundPage';
import { getConfig } from "@root/config/config";
import {
  // offersBel,
  offersSochi,
  // offersVladimir
} from "./data";
import { regionContent } from "@kursk/content/regionContent";
import { LayoutByData } from "@kursk/components/ui/LayoutByData/LayoutByData";
import { LayoutByIframe } from "@kursk/components/ui/LayoutByIframe/LayoutByIframe";

const offersHash = {
  // bel: offersBel,
  // vladimir: offersVladimir,
  sochi: offersSochi,
};

const config = getConfig();

export const PublicAgreement = () => {
  const offerData = offersHash[getConfig().theme];

  if (!offerData && !regionContent.agreementFilePath) {
    return <NotFoundPage />;
  }

  return offerData ?
    <LayoutByData offerData={offerData} /> :
    <LayoutByIframe config={config} filePath={regionContent.agreementFilePath} />
}
